import {
  ChangeDetectorRef,
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { catchError, first, firstValueFrom, map, throwError } from 'rxjs';

import { Store } from '@ngrx/store';

import { MasterFetchService } from '../../../fetches/services/master-fetch.service';
import { NgRxState } from '../../../modules/app-ngrx.module';
import { MasterAction } from '../../../stored/global/actions';

@Directive({
  selector: '[xbahtMasterDocumentRequest]',
})
export class DocumentRequestDirective implements OnInit {
  constructor(
    private cd: ChangeDetectorRef,
    private ngrxStore: Store<NgRxState>,
    private templateRef: TemplateRef<{
      $implicit: {
        id: string;
        code: string;
        sequence: number;
        name: string;
        description: string;
      };
      index: number;
      first: boolean;
      last: boolean;
      even: boolean;
      odd: boolean;
      count: number;
    }>,
    private viewContainer: ViewContainerRef,
    private masterFetchService: MasterFetchService
  ) {}

  async ngOnInit(): Promise<void> {
    const document_requests = await firstValueFrom(
      this.ngrxStore
        .select('Master')
        .pipe(map((item) => item.document_requests))
    );
    if (document_requests.length != 0) {
      for (let index = 0; index < document_requests.length; index++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: document_requests[index],
          index,
          first: index === 0,
          last: index === document_requests.length - 1,
          even: (index & 1) === 0,
          odd: (index & 1) === 1,
          count: document_requests.length,
        });
      }

      this.cd.detectChanges();
    } else {
      this.masterFetchService
        .documentRequest({})
        .pipe(
          first(),
          catchError((error) => throwError(() => error))
        )
        .subscribe((item) => {
          if (item.status && item.payload) {
            this.ngrxStore.dispatch(
              MasterAction.SetDocumentRequest({
                document_requests: item.payload,
              })
            );

            this.viewContainer.clear();
            for (let index = 0; index < item.payload.length; index++) {
              this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.payload[index],
                index,
                first: index === 0,
                last: index === item.payload.length - 1,
                even: (index & 1) === 0,
                odd: (index & 1) === 1,
                count: item.payload?.length,
              });
            }

            this.cd.detectChanges();
          }
        });
    }
  }
}
